import {
  AmazonSignIn,
  AwsS3Icon,
  FailedSyncCheck,
  GoogleDriveIcon,
  GoogleSignIn,
  OrangeRotate,
  SuccessSyncedCheck,
} from '../../../../assets/images';

export const knowledgeBaseText = 'Knowledge Base';
export const createFolderText = 'Create Folder';
export const sortByText = 'Sort By';
export const editText = 'Edit';
export const deleteText = 'Delete';
export const shareText = 'Share';
export const uploadText = 'Upload';
export const uploadTooltipText = 'Hold on! we are still uploading your previous folder';
export const EmbeddedModelsText = 'Choose the Embedding Model';
export const EmbeddedServiceText = 'Select the Service';
export const FolderNameText = 'Folder Name';
export const BrowseFileText = 'Browse File';
export const DropFiles = 'Drag & drop files or';
export const UploadText = 'Files Uploaded';
export const ChunkByText = 'Chunk Size (Tokens)';
export const ChunkSizeText = 'Chunk size';
export const ChunkOverLapText = 'Chunk Overlap (Tokens)';
export const OverLapText = 'Overlap size';
export const AddFilesText = 'Add Files';
export const AddFilesLoading = 'Adding Files...';
export const NoDataText = 'Data not found';
export const KBTableColumnData = ['FILE NAME', 'FILE OWNER', 'TIMESTAMP', 'ACTIONS'];
export const WarningText =
  'NOTE: No embedded models are available. Please grant access to at least one model.';
export const FileNameText = 'File Name';
export const FolderStructureText = 'Project Structure';

export const chunkInput = [
  {
    id: 'chunk_words',
    label: 'Chunk Size',
    type: 'number',
    className: 'ml-2 placeholder:text-sm border-[#E4E4E7] rounded-md w-full',
    required: true,
    labelHelper: 'Size (Token)',
    placeholder: 'Number of Tokens',
    error: '',
    min: 0,
    infoIconText:
      'How much text is grouped into each chunk. Use 1000 for standard docs (PDFs, reports), 1500 for books/manuals, 250–500 for short or dense content (FAQs, emails), and 300 for code.',
  },
  {
    id: 'chunk_overlap',
    label: 'Chunk Overlap',
    type: 'number',
    className: 'ml-2 placeholder:text-sm border-[#E4E4E7] rounded-md w-full',
    required: true,
    labelHelper: 'Overlap (Token)',
    placeholder: 'Enter the size',
    error: 'Overlap cannot be greater than half of chunk size.',
    min: 0,
    infoIconText:
      "How much text is shared between chunks so sentences aren't cut off. Aim for 10–20% of your chunk size (e.g., 100–200 for a chunk size of 1000).",
  },
];

export const ServiceOptions = [
  { id: 'system', name: 'System' },
  { id: 'G-drive', name: 'Google Drive' },
  { id: 'aws', name: 'Amazon S3' },
];

export const FrequencyOptions = [
  { label: '24hrs', value: '1d' },
  { label: 'Last 7 days', value: '7d' },
  { label: 'Last month', value: '30d' },
];

export const FileDropdownOptions22 = [
  { label: 'Pdf', value: '.pdf' },
  { label: 'Txt', value: '.txt' },
];

export const FileDropdownOptions = [
  {
    heading: 'FileType',
    options: [
      { label: 'Pdf', value: '.pdf' },
      { label: 'Txt', value: '.txt' },
      { label: 'Docx', value: '.docx' },
    ],
  },
];

export const knowledgeBaseTabs = [
  { id: 0, label: 'My Folders', value: 'my_folders' },
  { id: 1, label: 'Public Folders', value: 'public_folders' },
];

export const uploadConfigs = [
  {
    id: 'G-drive',
    service: 'G-drive',
    title: 'Upload Files to Knowledge Base',
    oauthButtonText: 'Sign in with Google',
    providerLabel: 'Google Drive',
    buttonIcon: GoogleSignIn,
    icon: GoogleDriveIcon,
    acceptedFileTypes: {
      'application/pdf': ['.pdf'],
      'text/plain': ['.txt'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    acceptedFormatsNote: 'Supported formats: TXT, PDF, DOCX',
  },
  {
    id: 'aws',
    service: 'aws',
    title: 'Upload Files to Knowledge Base',
    oauthButtonText: 'Sign in with Amazon S3',
    providerLabel: 'Amazon S3',
    buttonIcon: AmazonSignIn,
    icon: AwsS3Icon,
    acceptedFileTypes: {
      'application/pdf': ['.pdf'],
      'text/plain': ['.txt'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    acceptedFormatsNote: 'Supported formats: TXT, PDF, DOCX',
  },
  {
    id: 'system',
    service: 'system',
    title: 'Upload Files to Knowledge Base',
    oauthButtonText: '',
    providerLabel: 'System',
    buttonIcon: '',
    icon: '',
    acceptedFileTypes: {
      'application/pdf': ['.pdf'],
      'text/plain': ['.txt'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    acceptedFormatsNote: 'Supported formats: TXT, PDF, DOCX',
  },
];

export const folderSelectionModalConfig = [
  {
    id: 'myFolder',
    name: 'myFolder',
    Title: 'Select a Folder from Google Drive',
    description: 'Please Select the folder below to proceed with your sync',
    subTitle: 'Choose Folders',
    saveButtonText: 'Upload',
    cancelButtonText: 'Back',
  },
  {
    id: 'G-drive',
    name: 'myFolder',
    Title: 'Select a Folder from Google Drive',
    description: 'Please Select the folder below to proceed with your sync',
    subTitle: 'Project Structure',
    modalLogo: GoogleDriveIcon,
    saveButtonText: 'Upload',
    savingButtonText: 'Uploading',
    cancelButtonText: 'Back',
  },
  {
    id: 'aws',
    name: 'aws',
    Title: 'Select a Folder from Amazon S3',
    modalLogo: AwsS3Icon,
    description: 'Please Select the folder below to proceed with your sync',
    subTitle: 'Project Structure',
    saveButtonText: 'Upload',
    savingButtonText: 'Uploading',
    cancelButtonText: 'Back',
  },
];

export const SyncedConfig = {
  default: {
    status: 'default',
    icon: SuccessSyncedCheck,
    text: 'Last sync:',
  },
  Success: { status: 'success', icon: SuccessSyncedCheck, text: 'Last sync:' },
  Error: { status: 'error', icon: FailedSyncCheck, text: 'Failed' },
  InProgress: { status: 'inProgress', icon: OrangeRotate, text: 'In Progress' },
};

export const AwsAuthModalConfig = {
  title: 'AWS Auth',
  description: 'Please enter your AWS credentials to proceed with the sync.',
  modalLogo: AwsS3Icon,
  confirmButtonText: 'Authenticate',
  cancelButtonText: 'Cancel',
  isLoadingText: 'Authenticating...',
  defaultValues: {
    accessKey: 'Access Key ID',
    secretKey: 'Secret Access Key',
  },
};
